import React from 'react';
import { useForm } from 'react-hook-form';
import { Field } from '@headlessui/react';
import FormSwitch from '@app/component/form/input/switch/FormSwitch';
import SwitchLabel from '@app/component/form/input/switch/SwitchLabel';
import DataProvider from '@app/model/_common/DataProvider';
import { findProviderData } from '@app/component/provider/FindProviderData';

const TOOLTIP_ID = 'promotions-tooltip';
const FUNDED_FIELD = 'includeBookingFunded';
const FUNDED_TIP = 'Booking.com starts and stops these discounts itself. We saw them flip between two fetches of the same night, so they are off by default.';

const FixedFilter: React.FunctionComponent<{ children: React.ReactNode; muted?: boolean }> =
	({ children, muted }) =>
		<span className={`inline-flex h-9 items-center gap-1.5 rounded-md px-3 text-sm ring-1 ring-inset ring-gray-300 ${
			muted === true ? 'bg-gray-50 text-gray-400' : 'bg-white text-gray-600'}`}>
			{children}
		</span>;

const PromotionsFilterBar: React.FunctionComponent<{
	nights: number
	includeBookingFunded: boolean
	onIncludeBookingFunded: (include: boolean) => void
}> = ({ nights, includeBookingFunded, onIncludeBookingFunded }) => {
	const form = useForm({ defaultValues: { [FUNDED_FIELD]: includeBookingFunded } });

	return <div className="border-b border-gray-200 bg-white">
		<div className="mx-auto flex max-w-7xl flex-wrap items-center gap-2 px-4 py-3 sm:px-6 lg:px-8">
			<FixedFilter>
				{findProviderData(DataProvider.BOOKING).icon}
				Booking.com
			</FixedFilter>
			<FixedFilter muted>Desktop</FixedFilter>
			<FixedFilter muted>Public rates</FixedFilter>
			<FixedFilter muted>{nights} {nights === 1 ? 'night' : 'nights'}</FixedFilter>
			<div className="mx-1 hidden h-6 border-l border-gray-300 md:block" />
			<Field className="flex items-center gap-2" data-tooltip-id={TOOLTIP_ID} data-tooltip-content={FUNDED_TIP}>
				<FormSwitch form={form} name={FUNDED_FIELD} label="Booking.com-funded deals"
					onChange={onIncludeBookingFunded} />
				<SwitchLabel label="Booking.com-funded deals" />
			</Field>
		</div>
	</div>;
};

export default PromotionsFilterBar;
